import { render, staticRenderFns } from "./localFileDialog.vue?vue&type=template&id=27962d1f&scoped=true&"
import script from "./localFileDialog.vue?vue&type=script&lang=js&"
export * from "./localFileDialog.vue?vue&type=script&lang=js&"
import style0 from "./localFileDialog.vue?vue&type=style&index=0&id=27962d1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27962d1f",
  null
  
)

export default component.exports